import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgMiniCheck = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.385 9.488a.8.8 0 011.293.936l-.063.088-4.375 5.25a.8.8 0 01-1.093.13l-.088-.076-2.625-2.625a.8.8 0 011.042-1.21l.09.078 2.004 2.005 3.815-4.576z"
      clipRule="evenodd"
    />
  </svg>
));
SvgMiniCheck.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgMiniCheck;
